<template>
  <card v-if="brands.length === 0" class="col" v-loading="loadingBrands">
    <h4 class="text-uppercase text-muted ls-1 mb-1 text-center">
      Não possui Dados
    </h4>
  </card>

  <div v-loading="loadingBrands" v-else>
    <collapse :multipleActive="false">
      <collapse-item
        v-for="(brand, index) in brands"
        @opening="updateActiveListItem(index)"
        :shouldClose="closeCollapse"
      >
        <h4 slot="title" class="mb-0">
          {{ brand.name }}
        </h4>

        <supplier-purchase-goal-table
          :active="activeListItem === index"
          :brand-id="brand.id"
          :filters="filters"
        />

      </collapse-item>
    </collapse>
    <base-pagination
      v-on:input="changePage"
      v-model="brands_paginated_data['page']"
      :total="brands_paginated_data['count']"
      :perPage="brands_paginated_data['per_page']"
    ></base-pagination>
  </div>
</template>

<script>

import Collapse from "@/components/Collapse/Collapse";
import CollapseItem from "@/components/Collapse/CollapseItem";
import SupplierPurchaseGoalTable from "@/views/SupplierPurchaseGoal/components/SupplierPurchaseGoalTable.vue";

export default {
  name: "SupplierPurchaseGoalList",
  components: {
    Collapse,
    CollapseItem,
    SupplierPurchaseGoalTable,
  },
  props: {
    filters: {
      type: Object,
      default: () => {},
      description: "Filters"
    },
  },
  data() {
    return {
      brands: [],
      brands_paginated_data: [],
      activeListItem: -1,
      loadingBrands: false,
      closeCollapse: false,
    }
  },
  methods: {
    async changePage(page) {
      this.closeCollapse = true
        this.activeListItem = -1
        await this.getBrands(page)
        this.closeCollapse = false
    },
    updateActiveListItem(index) {
      this.activeListItem = index
    },
    async getBrands(page = 1) {
      let params = { page: page }
      const acceptedFilters =  ['brand_id', 'preferredproduct_id', 'group_id']
      const brandsFilter = Object.keys(this.filters).
        filter((key) => acceptedFilters.includes(key)).
        reduce((cur, key) => { return Object.assign(cur, { [key]: this.filters[key] })}, {});

      params.q = (Object.keys(brandsFilter).length > 0) ? brandsFilter : {}

      if (params.q && params.q.brand_id) {
        params.q.id     = params.q.brand_id
        delete params.q.brand_id
      }

      params.q.with_preferredproducts = true

      this.loadingBrands = true
      const response = await this.$http.secured.get('/api/v2/brands', {
        params: params
      })

      this.brands_paginated_data = response.data
      this.brands = this.brands_paginated_data.data
      this.loadingBrands = false

    },
  },
  watch: {
    filters: {
      handler: async function (val) {
        this.closeCollapse = true
        this.activeListItem = -1
        await this.getBrands()
        this.closeCollapse = false
      },
    },
  }
}
</script>
